export default {
    "name": "LegalPage",
    "kind": "HoudiniQuery",
    "hash": "e03a1f6e5533032850f223c5b841b702d2e9d2c0fda7438c828f8f3039a1094e",

    "raw": `query LegalPage($slug: String!) {
  legalPage(where: {slug: $slug}) {
    id
    updatedAt
    title
    content {
      html
    }
  }
}
`,

    "rootType": "Query",

    "selection": {
        "fields": {
            "legalPage": {
                "type": "LegalPage",
                "keyRaw": "legalPage(where: {slug: $slug})",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "updatedAt": {
                            "type": "DateTime",
                            "keyRaw": "updatedAt",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "nullable": true,
                            "visible": true
                        },

                        "content": {
                            "type": "RichText",
                            "keyRaw": "content",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "html": {
                                        "type": "String",
                                        "keyRaw": "html",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "slug": "String"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=24ad46473625169456c2279655e4d6e6ffb486b7545a3f5479a6355bc032e209";